/**
 * @type {Object}
 * @property {array}  data  Item data
 */
const initialState = {
    parameters: []
};

/**
 * 
 * @param {Object} state    Initial state of store 
 * @param {Object} action   action data
 * @returns {Object} newState 
 */
const reducerParameters = (state = initialState, action) => {
    const newState = { ...state }
    switch (action.type) {
        case 'FETCH_PARAMETERS':
            var { data } = action;
            newState.parameters = data;
            break;

        default:
            break;
    }
    return newState;
}

export default reducerParameters;